import { styled } from "@mui/material/styles";

const PaginationContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  zIndex: 1,
  marginBottom: 5,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 10,
  },
  "& .swiper-pagination-bullet": {
    width: 8,
    height: 8,
    background: "#E7E7EA",
    opacity: 1,
    [theme.breakpoints.up("mobile")]: {
      width: 12,
      height: 12,
    },
    "&.swiper-pagination-bullet-active": {
      background: "#5080FF",
    },
  },
}));

const Pagination = () => {
  return <PaginationContainer className="category-pagination" data-testid="category-pagination" />;
};

export default Pagination;
